import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class VpnReservedService extends BaseService{
	constructor() {
		super('/VpnReserved');
	}

	public getAllByFilter(filter: VpnReservedFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getAllBaseVpn(filter: VpnReservedFilter) {
		return super.getAllByFilterBase(filter, 'base-vpn');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}
}

export class VpnReservedFilter extends BaseFilter{
	constructor( idTenant?: number | null) {
		super();
		
		this._idTenant = idTenant;
	}
	
	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},			
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
	
		);

		return data;
	};
}